import React from "react";
import {SiteData} from "../../Constants/siteData";
import {PageWrapper} from "../../Components/PageWrapper/PageWrapper";
import PageHeader from "../../Components/common/PageHeader";
import ServicePageTemplate from "../../Containers/ServiceContainers/ServicePageTemplate";
import {SEO} from "../../Components/SEO/SEO";

export default function EmergencyTreeService() {
    return (
        <PageWrapper>
            <SEO title={SiteData.emergencyTreeServices.metaData.title} description={SiteData.emergencyTreeServices.metaData.description}/>
            <PageHeader header={SiteData.emergencyTreeServices.h1} subtitle={SiteData.emergencyTreeServices.subtitle}/>
            <ServicePageTemplate body={SiteData.emergencyTreeServices.body}/>
        </PageWrapper>
    )
}
